import axios from 'axios';
import routes from '../../../app/routes';

export const Actions = {
  loadPaymentMethod: (dispatch, enterpriseId) => {
    axios
      .get(routes.api.enterprises.payment_method(enterpriseId))
      .then((resp) => {
        dispatch({ type: 'loadMaymentMethod', paymentMethod: resp.data.data });
      });
  },
  loadBillingInformation: (dispatch, enterpriseId) => {
    axios
      .get(routes.api.enterprises.billing_information(enterpriseId))
      .then((resp) => {
        dispatch({
          type: 'loadBillingInformation',
          billingInformation: resp.data.data,
        });
      });
  },
  saveBillingInformation: (dispatch, enterpriseId, params, callback) => {
    axios
      .post(
        routes.api.enterprises.save_billing_information(enterpriseId),
        params,
      )
      .then((resp) => {
        dispatch({
          type: 'loadBillingInformation',
          billingInformation: resp.data.data,
        });
        callback();
      });
  },
  w9FormLink: (callback) => {
    axios
      .get(
        routes.api.enterprises.w9form_link,
      )
      .then((resp) => {
        callback(resp.data);
      });
  },
};
